import TeamSvg from '../../../assets/team.svg?react';
import { IconProps } from '../../types/IconProps';

export function Team({ size = 20, ...props }: IconProps) {
  return <TeamSvg data-testid="team-icon" width={size} height={size} {...props} />;
}

export default Team;
